import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getPendingPromo, clearPendingPromo, promoKind, PENDING_PROMO_EVENT } from './../../utils/promoCode';
import './PromoOverview.css';

/**
 * บอกลูกค้าที่มาจากปุ่ม "จองเลย" ของหน้า voucher/คูปอง ว่ารหัสยังถือไว้อยู่
 * และจะถูกใส่ให้เองตอนจอง -- ไม่งั้นลูกค้าจะไม่แน่ใจว่าต้องจดรหัสไปกรอกเองไหม
 */
const PendingPromoBanner = ({ hotelId }) => {
  const { t } = useTranslation();
  const [pending, setPending] = useState(() => getPendingPromo(hotelId));

  useEffect(() => {
    const refresh = () => setPending(getPendingPromo(hotelId));
    refresh();

    window.addEventListener(PENDING_PROMO_EVENT, refresh);
    window.addEventListener('storage', refresh); // เปลี่ยนจากอีกแท็บ
    return () => {
      window.removeEventListener(PENDING_PROMO_EVENT, refresh);
      window.removeEventListener('storage', refresh);
    };
  }, [hotelId]);

  if (!pending) return null;

  const kindLabel = t(promoKind(pending.code) === 'voucher' ? 'promo_kind_voucher' : 'promo_kind_coupon');

  return (
    <div className="promo-pending" role="status">
      <div className="promo-pending__text">
        <p className="promo-pending__title">{t('promo_pending_title', { kind: kindLabel, code: pending.code })}</p>
        <p className="promo-pending__sub">{t('promo_pending_hint')}</p>
      </div>
      <button type="button" className="promo-pending__remove" onClick={() => clearPendingPromo()}>
        {t('promo_pending_remove')}
      </button>
    </div>
  );
};

export default PendingPromoBanner;
